import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// import MenuItem from '../components/MenuItem';
import '../App.css';
// import _ from 'lodash';
import Auth from '../core/services/auth';
import Avatar from 'react-avatar';
import InfiniteScroll from 'react-infinite-scroll-component';
import { DataResponsetype } from '../core/lib/types';
import Back from '../components/backComponent';
import VendorStoryComponent from '../components/VendorStoryComponent';

function VendorProfile() {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { name, id } = state || {};
    const [ type, setType ] = useState("")
    const [ vendor, setVendor ] = useState<any>({
      _id: '',
      name: '',
      logo: null,
      website: '',
      location: ''
    })

    // console.log(name)
    // console.log(id)

    // let vendor:any

    // if (name && !id) {
    //   vendor = Auth.getVendor().find((e: { name: any; })=>e.name === name)
    // }  else if ( name && typeof(id) !== "undefined") {

      
    // } 


    // console.log(vendor)

    useEffect(()=>{
      if (!name && typeof(vendor) === "undefined") {
          navigate('/profile')
      }
    })

    const [ params, setParams ] = useState({
        page: 1, limit: 6, sort: "-createdAt", vendorId: vendor.id
    })
    

    const [ story, setStory ] = useState<DataResponsetype>({ total: 0, pages: 0, page: 0, limit: 0, data: [] })

    const getData = useCallback(() => {
      //
      // setType(args)
      if (type === "posts") {
        //
        // Auth.api.get("/posts", { params: params} ).then(res=>{
        //     setPost(res.data.data)
        // })

      } else if (type === "pins") {
          //
          // Auth.api.get("/pins", { params: params}).then(res=>{
          //     setPost(res.data.data)
          // })
      } else {
          Auth.api.get("/stories", { params: params} ).then(res=>{
            setStory(res.data.data)
          })
      }

    }, [params, type ])

    // use effect
    useEffect(() => {
       
        Auth.api.get("/vendors/"+id).then(res=>{
            setVendor(res.data.data)
        })
    
        setType('')
        getData()
      
    }, [setType, getData, navigate, id])

    const onSet = (ars: string) => {
      //
      setParams({
          page: 1, limit: 6, sort: "-createdAt", vendorId: vendor.id
      })
      setType(ars)
    }

    const fetchData = () => {
      //
      if (story.data.length >= story.total) {
          // setMore(false)
          return;
      }

        params.page++

      //   console.log(params)

      Auth.api.get("/stories", { params: params} ).then(res=> {
        //
          setStory({
            total: story.total, 
            pages: story.pages, 
            page: story.page, 
            limit: story.limit,
            data: story.data.concat(res.data.data.data)
          })

          console.log(story.data)
            
          console.log(params)
        })
        .catch(err=>{
    
          console.log(err)

        })
    }

    const _stories = story.data.length > 0 ? story.data : []

    const storyItems = _stories.map(
        (story: any, index) => 
          <VendorStoryComponent 
            key={index}
            caption={story.caption} 
            media={story.media} 
            vendor={story.vendor} 
            createdAt={story.createdAt} 
            vendorId={story.vendorId}
            id={story.id} 
            />
          
      )

    

    return (
        <section className='dark:bg-gray-800 dark:text-white'>
          <div className=' w-full py-5 mb-2'>
            <Back className='py-4 px-5 absolute start-0 flex' title='Profile'/>
            <div className='py-3 px-5 absolute end-0 flex'>
            
            </div>
          </div>
          <div className="flex flex-col px-6 py-8 mx-auto md:h-screen ">
            {vendor &&
              <div className="flex flex-row items-center space-y-1 relative">
                      {(vendor.logo) ?
                                        
                        <div style={{width:'65px', height: ''}} className="border bg-gray-100 border-slate-400 rounded-full">
                            <div className="bg-white block rounded-full  hover:-rotate-6 transform transition aspect-square flex align-center">
                              <img alt='profile' className='rounded-full object-cover p-0.5' src={vendor.logo.url}/>
                            </div>
                        </div>              
                      :
                        !(vendor.logo) &&
                        <Avatar round={true} size='65' name={vendor.name} />
                      }
                      {/* <div className='relative' style={{width:'105px', height: '5px'}}> */}
                      
                        {/* </div> */}
                  <div className='ml-4 text-left'>
                      <h2 className='text-md font-bold mb-0 pb-0'>{vendor.name}</h2>
                      <p className='text-sm text-gray- mb-0 pb-0'>{vendor.description }
                      </p>
                      <p className='text-xs text-gray-500 mb-0 pb-0'>{vendor.website ? vendor.website : vendor.location ? vendor.location.name.split(',')[1]+', '+vendor.location.name.split(',')[2] : '' }</p>
                  </div>
              </div>
            }
            <div className="md:h-screen mx-auto space-y-2 mb-20 mt-10">
                  <InfiniteScroll
                          dataLength={story.data.length}
                          hasMore={true}
                          next={fetchData}
                          loader={<p className='text-center'></p>}
                      >
                          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 pt-1">
                          
                              {
                                  // _posts.map(
                                  //     (post: any, index) => 
                                  //       <ProfileStoryComponent 
                                  //         key={index}
                                  //         caption={post.caption} 
                                  //         media={post.media} 
                                  //         user={post.user} 
                                  //         location={post.location} 
                                  //         id={post.id} 
                                  //         vendor={post.vendor}
                                  //         createdAt={post.createdAt}
                                  //         meta={post.meta}
                                  //         user_action={post.user_action}
                                  //         profile={post.profile}
                                  //         />
                                      
                                  //   )
                                  storyItems
                              }
                          </div>
                  </InfiniteScroll>
                <button className='invisible' onClick={e=>onSet('')}></button>
                {/* file input */}
            </div>
            {/* Form Modal */}
            

          </div>
        </section>
    );
  }
  
  export default VendorProfile;
  

